<template>
  <v-container class="pa-0 ma-0">

    <!-- DIALOGS OF TYPE 'POPUP' -->
    <v-dialog v-model="dialogs['redeemCode'].visible"
              persistent :max-width="maxWidth">
      <redeem-code-dialog ref="redeemCode"
                          :data="dialogs['redeemCode'].data"
                                type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['registrationCodeValid'].visible"
              persistent :max-width="maxWidth">
      <registration-code-valid-dialog :data="dialogs['registrationCodeValid'].data"
                                      ref="registrationCodeValid"
                                      type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['registrationCodeError'].visible"
              persistent :max-width="maxWidth">
      <registration-code-error-dialog ref="registrationCodeError"
                                      type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['registrationMailError'].visible"
              persistent :max-width="maxWidth">
      <registration-mail-error-dialog ref="registrationMailError"
                                      type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['invitationCodeError'].visible"
              persistent :max-width="maxWidth">
      <invitation-code-error-dialog ref="invitationCodeError"
                                    type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['profileConfirmDelete'].visible"
              persistent max-width="550">
      <profile-confirm-delete-dialog ref="profileConfirmDelete"
                                     type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['clearCache'].visible"
              persistent max-width="550">
      <clear-cache-dialog ref="clearCache"
                          type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['gatewayOfflineHelp'].visible"
              persistent max-width="550">
      <gateway-offline-help-dialog ref="gatewayOfflineHelp"
                                   type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['firstLaunch'].visible"
              persistent max-width="550">
      <first-launch-dialog ref="firstLaunch"
                           type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['infoText'].visible"
              persistent max-width="550">
      <info-text-dialog :data="dialogs['infoText'].data"
                        ref="infoText"
                        type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['deleteEnodeConnection'].visible"
              persistent max-width="550">
      <delete-enode-connection-dialog :data="dialogs['deleteEnodeConnection'].data"
                                      ref="deleteEnodeConnection"
                                      type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['unlinkEnodeUser'].visible"
              persistent max-width="550">
      <unlink-enode-user-dialog ref="unlinkEnodeUser"
                                type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['confirmation'].visible"
              persistent :max-width="maxWidth">
      <confirmation-dialog :data="dialogs['confirmation'].data"
                           ref="confirmation"
                           type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['energylineAccountLinking'].visible"
              persistent width="90%" max-width="550">
      <energyline-account-linking-dialog :data="dialogs['energylineAccountLinking'].data"
                              ref="energylineAccountLinking"
                              type="POPUP"/>
    </v-dialog>

    <v-dialog v-model="dialogs['changeMail'].visible"
              persistent :max-width="maxWidth">
      <change-mail-dialog :data="dialogs['changeMail'].data"
                          ref="changeMail"
                          type="POPUP"/>
    </v-dialog>

    <!-- individual dialog types -->
   <v-dialog v-model="dialogs['onboarding'].visible"
              persistent width="90%" :max-width="750">
      <onboarding-dialog :data="dialogs['onboarding'].data"
                         ref="onboarding"
                         type="POPUP"/>
    </v-dialog>

    <!-- DIALOGS OF TYPE 'OVERLAY' -->
    <!-- v-navigation-drawers load content even if v-model is false. Add v-if to content if it should only be executed
         when the corresponding overlay is visible. -->
    <v-navigation-drawer v-model="dialogs['language'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <language-dialog v-if="dialogs['language'].visible"
                       ref="language"
                       type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['changePassword'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <change-password-dialog v-if="dialogs['changePassword'].visible"
                              ref="changePassword"
                              type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['darkMode'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <dark-mode-dialog v-if="dialogs['darkMode'].visible"
                        ref="darkMode"
                        type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['inbox'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <inbox-dialog v-if="dialogs['inbox'].visible"
                    :data="dialogs['inbox'].data"
                    ref="inbox"
                    type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['contact'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <contact-dialog v-if="dialogs['contact'].visible"
                      :data="dialogs['contact'].data"
                      ref="contact"
                      type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['form'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <form-dialog v-if="dialogs['form'].visible"
                   :data="dialogs['form'].data"
                   ref="form"
                   type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['hubspotForm'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <hubspot-form-dialog v-if="dialogs['hubspotForm'].visible"
                           :data="dialogs['hubspotForm'].data"
                           ref="hubspotForm"
                           type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['hubspotCalendar'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <hubspot-calendar-dialog v-if="dialogs['hubspotCalendar'].visible"
                               :data="dialogs['hubspotCalendar'].data"
                               ref="hubspotCalendar"
                               type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['device'].visible"
                         fixed right temporary stateless
                         :class="maximized ? 'width-large' : 'width-small'">
      <device-dialog v-if="dialogs['device'].visible"
                     @maximize="maximized = true"
                     @minimize="maximized = false"
                     ref="device"
                     :data="dialogs['device'].data"
                     type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addGateway'].visible"
                         fixed right temporary stateless
                         class="width-medium">
      <add-gateway-dialog v-if="dialogs['addGateway'].visible"
                          ref="addGateway"
                          :data="dialogs['addGateway'].data"
                          type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addDevice'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-device-dialog v-if="dialogs['addDevice'].visible"
                         ref="addDevice"
                         :data="dialogs['addDevice'].data"
                         type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['newPassword'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <new-password-dialog v-if="dialogs['newPassword'].visible"
                           :data="dialogs['newPassword'].data"
                           ref="newPassword"
                           type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['removeDevice'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <remove-device-dialog v-if="dialogs['removeDevice'].visible"
                            ref="removeDevice"
                            :data="dialogs['removeDevice'].data"
                            type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['changeSite'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <change-site-dialog v-if="dialogs['changeSite'].visible"
                          ref="changeSite"
                          :data="dialogs['changeSite'].data"
                          type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['faq'].visible"
                         fixed right temporary stateless
                         class="width-medium">
      <faq-dialog v-if="dialogs['faq'].visible"
                  ref="faq"
                  :data="dialogs['faq'].data"
                  type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['inviteUser'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <invite-user-dialog v-if="dialogs['inviteUser'].visible"
                          ref="inviteUser"
                          type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['editDevicePermissions'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <edit-device-permissions-dialog v-if="dialogs['editDevicePermissions'].visible"
                                      ref="editDevicePermissions"
                                      :data="dialogs['editDevicePermissions'].data"
                                      type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['changeUserData'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <change-user-data-dialog v-if="dialogs['changeUserData'].visible"
                               ref="changeUserData"
                               type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['connectedAccounts'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <connected-accounts-dialog v-if="dialogs['connectedAccounts'].visible"
                                 ref="connectedAccounts"
                                 type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['energylineDataSupport'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <energyline-data-support-dialog v-if="dialogs['energylineDataSupport'].visible"
                                      :data="dialogs['energylineDataSupport'].data"
                                      ref="energylineDataSupport"
                                      type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['contentDetailPage'].visible"
                         fixed right temporary stateless
                         class="width-small px-0">
      <content-detail-page-dialog v-if="dialogs['contentDetailPage'].visible"
                                  :data="dialogs['contentDetailPage'].data"
                                  ref="contentDetailPage"
                                  type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['pflegixCallback'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <pflegix-callback-dialog v-if="dialogs['pflegixCallback'].visible"
                               :data="dialogs['pflegixCallback'].data"
                               ref="pflegixCallback"
                               type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addSmarthomeComponent'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-smarthome-component-dialog v-if="dialogs['addSmarthomeComponent'].visible"
                                      ref="addSmarthomeComponent"
                                      :data="dialogs['addSmarthomeComponent'].data"
                                      type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addEmobilityConnection'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-emobility-connection-dialog v-if="dialogs['addEmobilityConnection'].visible"
                                       ref="addEmobilityConnection"
                                       :data="dialogs['addEmobilityConnection'].data"
                                       type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addHeatingMode'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-heating-mode-dialog v-if="dialogs['addHeatingMode'].visible"
                               ref="addHeatingMode"
                               :data="dialogs['addHeatingMode'].data"
                               type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['enodeTimeSetting'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <enode-time-setting-dialog v-if="dialogs['enodeTimeSetting'].visible"
                                 ref="enodeTimeSetting"
                                 :data="dialogs['enodeTimeSetting'].data"
                                 type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['enodeGreenChargingSetting'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <enode-green-charging-setting-dialog v-if="dialogs['enodeGreenChargingSetting'].visible"
                                           ref="enodeGreenChargingSetting"
                                           :data="dialogs['enodeGreenChargingSetting'].data"
                                           type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['heatingModesOverview'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <heating-modes-overview-dialog v-if="dialogs['heatingModesOverview'].visible"
                                     ref="heatingModesOverview"
                                     :data="dialogs['heatingModesOverview'].data"
                                     type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addRule'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-rule-dialog v-if="dialogs['addRule'].visible"
                       ref="addRule"
                       :data="dialogs['addRule'].data"
                       type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addScene'].visible"
                         fixed right temporary stateless
                         id="add-scene-dialog-nav-drawer"
                         class="width-small">
      <add-scene-dialog v-if="dialogs['addScene'].visible"
                        ref="addScene"
                        :data="dialogs['addScene'].data"
                        type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addNukiBridge'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-nuki-bridge-dialog v-if="dialogs['addNukiBridge'].visible"
                              ref="addNukiBridge"
                              :data="dialogs['addNukiBridge'].data"
                              type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addWilkaLock'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-wilka-lock-dialog v-if="dialogs['addWilkaLock'].visible"
                              ref="addWilkaLock"
                              :data="dialogs['addWilkaLock'].data"
                              type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['wilkaLock'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <wilka-lock-dialog v-if="dialogs['wilkaLock'].visible"
                             ref="wilkaLock"
                             :data="dialogs['wilkaLock'].data"
                             type="OVERLAY"/>
    </v-navigation-drawer>


    <v-navigation-drawer v-model="dialogs['userPermission'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <user-permission-dialog v-if="dialogs['userPermission'].visible"
                              ref="userPermission"
                              :data="dialogs['userPermission'].data"
                              type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addSite'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-site-dialog v-if="dialogs['addSite'].visible"
                       ref="addSite"
                       :data="dialogs['addSite'].data"
                       type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['sGReady'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <s-g-ready-dialog v-if="dialogs['sGReady'].visible"
                        ref="sGReady"
                        :data="dialogs['sGReady'].data"
                        type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addKaadasPin'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-kaadas-pin-dialog v-if="dialogs['addKaadasPin'].visible"
                             ref="addKaadasPin"
                             :data="dialogs['addKaadasPin'].data"
                             type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addChargingStation'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-charging-station-dialog v-if="dialogs['addChargingStation'].visible"
                                   ref="addChargingStation"
                                   :data="dialogs['addChargingStation'].data"
                                   type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addOcppChargePoint'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-ocpp-charge-point-dialog v-if="dialogs['addOcppChargePoint'].visible"
                                    ref="addOcppChargePoint"
                                    :data="dialogs['addOcppChargePoint'].data"
                                    type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['ocppChargePointDetails'].visible"
                         fixed right temporary stateless
                         :class="maximized ? 'width-large' : 'width-small'">
      <ocpp-charge-point-details-dialog v-if="dialogs['ocppChargePointDetails'].visible"
                                        ref="ocppChargePointDetails"
                                        @maximize="maximized = true"
                                        @minimize="maximized = false"
                                        :data="dialogs['ocppChargePointDetails'].data"
                                        type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['location'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <location-dialog v-if="dialogs['location'].visible"
                         ref="location"
                         :data="dialogs['location'].data"
                         type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['smartChargingOnboarding'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <smart-charging-onboarding-dialog v-if="dialogs['smartChargingOnboarding'].visible"
                       ref="smartChargingOnboarding"
                       :data="dialogs['smartChargingOnboarding'].data"
                       type="OVERLAY"/>
    </v-navigation-drawer>

    <v-navigation-drawer v-model="dialogs['addRoom'].visible"
                         fixed right temporary stateless
                         class="width-small">
      <add-room-dialog v-if="dialogs['addRoom'].visible"
                                        ref="addRoom"
                                        :data="dialogs['addRoom'].data"
                                        type="OVERLAY"/>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import RedeemCodeDialog from "@/templates/dialogs/RedeemCodeDialog.vue";
import RegistrationCodeValidDialog from "@/templates/dialogs/RegistrationCodeValidDialog";
import RegistrationCodeErrorDialog from "@/templates/dialogs/RegistrationCodeErrorDialog";
import RegistrationMailErrorDialog from "@/templates/dialogs/RegistrationMailErrorDialog";
import ProfileConfirmDeleteDialog from "@/templates/dialogs/ProfileConfirmDeleteDialog";
import LanguageDialog from "@/templates/dialogs/LanguageDialog";
import ChangePasswordDialog from "@/templates/dialogs/ChangePasswordDialog";
import DarkModeDialog from "@/templates/dialogs/DarkModeDialog";
import InboxDialog from "@/templates/dialogs/InboxDialog";
import ContactDialog from "@/templates/dialogs/ContactDialog";
import FormDialog from "@/templates/dialogs/FormDialog";
import HubspotFormDialog from "@/templates/dialogs/HubspotFormDialog";
import HubspotCalendarDialog from "@/templates/dialogs/HubspotCalendarDialog";
import ClearCacheDialog from "@/templates/dialogs/ClearCacheDialog";
import GatewayOfflineHelpDialog from "@/templates/dialogs/GatewayOfflineHelpDialog";
import FirstLaunchDialog from "@/templates/dialogs/FirstLaunchDialog";
import DeviceDialog from "@/templates/dialogs/devices/DeviceDialog";
import AddGatewayDialog from "@/templates/dialogs/addGateway/AddGatewayDialog";
import AddDeviceDialog from "@/templates/dialogs/addDevice/AddDeviceDialog";
import InfoTextDialog from "@/templates/dialogs/InfoTextDialog";
import DeleteEnodeConnectionDialog from "@/templates/dialogs/DeleteEnodeConnectionDialog";
import UnlinkEnodeUserDialog from "@/templates/dialogs/UnlinkEnodeUserDialog";
import RemoveDeviceDialog from "@/templates/dialogs/removeDevice/RemoveDeviceDialog";
import NewPasswordDialog from "@/templates/dialogs/NewPasswordDialog";
import ChangeSiteDialog from "@/templates/dialogs/ChangeSiteDialog";
import FaqDialog from "@/templates/dialogs/FaqDialog";
import EnodeTimeSettingDialog from "@/templates/dialogs/enode/EnodeTimeSettingDialog.vue";
import EnodeGreenChargingSettingDialog from "@/templates/dialogs/enode/EnodeGreenChargingSettingDialog.vue";
import InviteUserDialog from "@/templates/dialogs/inviteUsers/InviteUserDialog";
import ConfirmationDialog from "@/templates/dialogs/ConfirmationDialog";
import EditDevicePermissionsDialog from "@/templates/dialogs/inviteUsers/EditDevicePermissionsDialog";
import InvitationCodeErrorDialog from "@/templates/dialogs/inviteUsers/InvitationCodeErrorDialog";
import ChangeUserDataDialog from "@/templates/dialogs/ChangeUserDataDialog";
import ConnectedAccountsDialog from "@/templates/dialogs/ConnectedAccountsDialog";
import OnboardingDialog from "@/templates/dialogs/OnboardingDialog";
import EnergylineDataSupportDialog from "@/templates/dialogs/energy/EnergylineDataSupportDialog.vue";
import AddHeatingModeDialog from "@/templates/dialogs/addAutomation/AddHeatingModeDialog";
import HeatingModesOverviewDialog from "@/templates/dialogs/HeatingModesOverviewDialog";
import ChangeMailDialog from "@/templates/dialogs/ChangeMailDialog.vue";
import PflegixCallbackDialog from "@/templates/dialogs/discover/PflegixCallbackDialog.vue";
import ContentDetailPageDialog from "@/templates/dialogs/ContentDetailPageDialog.vue";
import AddSmarthomeComponentDialog from "@/templates/dialogs/AddSmarthomeComponentDialog.vue";
import AddEmobilityConnectionDialog from "@/templates/dialogs/AddEmobilityConnectionDialog.vue";
import AddRuleDialog from "@/templates/dialogs/automations/AddRuleDialog.vue";
import AddNukiBridgeDialog from "@/templates/dialogs/addNukiBridge/AddNukiBridgeDialog.vue";
import AddWilkaLockDialog from "@/templates/dialogs/AddWilkaLockDialog.vue";
import WilkaLockDialog from "@/templates/dialogs/WilkaLockDialog.vue";
import AddSceneDialog from "@/templates/dialogs/automations/AddSceneDialog.vue";
import UserPermissionDialog from "@/templates/dialogs/userPermission/UserPermissionDialog.vue";
import AddKaadasPinDialog from "@/templates/dialogs/AddKaadasPinDialog.vue";
import AddSiteDialog from "@/templates/dialogs/AddSiteDialog.vue";
import SGReadyDialog from "@/templates/dialogs/sgReady/SGReadyDialog.vue";
import AddChargingStationDialog from "@/templates/dialogs/emobility/AddChargingStationDialog.vue";
import AddOcppChargePointDialog from "@/templates/dialogs/emobility/AddOcppChargePointDialog.vue";
import OcppChargePointDetailsDialog from "@/templates/dialogs/emobility/OcppChargePointDetailsDialog.vue";
import EnergylineAccountLinkingDialog from "@/templates/dialogs/energy/EnergylineAccountLinkingDialog.vue";
import LocationDialog from "@/templates/dialogs/enode/LocationDialog.vue";
import SmartChargingOnboardingDialog from "@/templates/dialogs/enode/SmartChargingOnboardingDialog.vue";
import AddRoomDialog from "@/templates/dialogs/AddRoomDialog.vue";

export const DialogTypes = Object.freeze({
  POPUP: "POPUP",
  OVERLAY: "OVERLAY"
});

export default {
  name: 'BisaDialog',

  components: {
    AddRoomDialog,
    SmartChargingOnboardingDialog,
    LocationDialog,
    EnergylineAccountLinkingDialog,
    OcppChargePointDetailsDialog,
    AddOcppChargePointDialog,
    AddChargingStationDialog,
    AddSiteDialog,
    SGReadyDialog,
    AddSceneDialog,
    AddRuleDialog,
    ContentDetailPageDialog,
    ChangeMailDialog,
    EnergylineDataSupportDialog,
    OnboardingDialog,
    ChangeUserDataDialog,
    ConnectedAccountsDialog,
    InvitationCodeErrorDialog,
    EditDevicePermissionsDialog,
    ConfirmationDialog,
    InviteUserDialog,
    ChangeSiteDialog,
    FaqDialog,
    EnodeTimeSettingDialog,
    EnodeGreenChargingSettingDialog,
    RemoveDeviceDialog,
    InfoTextDialog,
    DeleteEnodeConnectionDialog,
    UnlinkEnodeUserDialog,
    AddDeviceDialog,
    AddGatewayDialog,
    DeviceDialog,
    FirstLaunchDialog,
    GatewayOfflineHelpDialog,
    ClearCacheDialog,
    FormDialog,
    HubspotFormDialog,
    HubspotCalendarDialog,
    ContactDialog,
    InboxDialog,
    ChangePasswordDialog,
    LanguageDialog,
    ProfileConfirmDeleteDialog,
    RegistrationMailErrorDialog,
    RegistrationCodeErrorDialog,
    RegistrationCodeValidDialog,
    RedeemCodeDialog,
    NewPasswordDialog,
    PflegixCallbackDialog,
    DarkModeDialog,
    AddSmarthomeComponentDialog,
    AddEmobilityConnectionDialog,
    AddHeatingModeDialog,
    HeatingModesOverviewDialog,
    AddNukiBridgeDialog,
    UserPermissionDialog,
    AddKaadasPinDialog,
    AddWilkaLockDialog,
    WilkaLockDialog
  },

  data: function () {
    return {
      maxWidth: 960,
      maximized: false,
      dialogs: {}, // dialogs model is auto-generated in created()
    }
  },

  methods: {
    /**
     * Calls the method init() on the dialog.
     * Don't forget to add a ref with the dialog key to the dialog component
     * @see https://rockethome.atlassian.net/wiki/spaces/DEV/pages/2491678721/Bisaknosp#Bisa-Dialog
     *
     * @param key
     */
    callDialogInit(key) {
      this.$nextTick(() => { // wait until refs are defined
        this.$refs[key].init()
      })
    },

    /**
     * toggles the dialog
     * @see https://rockethome.atlassian.net/wiki/spaces/DEV/pages/2491678721/Bisaknosp#Bisa-Dialog
     *
     * @param key
     * @param visible
     * @param data
     */
    toggle(key, visible = null, data = null) {
      if (!(key in this.dialogs)) {
        console.error("no dialog with key " + key + " registered!")
        return
      }

      this.dialogs[key].data = data
      data?.maxWidth ? this.maxWidth = data.maxWidth : 960

      this.dialogs[key].visible = visible ? visible : !this.dialogs[key].visible

      // Render dialog
      this.$forceUpdate()

      if (this.dialogs[key].visible === false) {
        this.emitClose(key)
      } else {
        // Hide vertical scroll bars on <html> when a dialog is opened
        let elHtml = document.getElementsByTagName('html')[0]
        elHtml.style.overflowY = 'hidden'

        // blur background if the dialog is of type POPUP
        this.$nextTick(() => { // wait until refs are defined
          if(this.$refs[key].$attrs?.type === DialogTypes.POPUP) {
            this.$emit('blur')
          }
        })
      }
    },

    /**
     * emits the dialog close event for v-navigation-drawers when clicked outside
     *
     * @param e
     */
    clickOutside(e) {
      if (e.target.className === "v-overlay__scrim") {
        this.emitClose(null)
      }
    },

    emitClose(key) {
      // reset fullscreen setting on close
      this.maximized = false

      this.$emit('close', key)

      // Reset vertical scroll bars on <html> when a dialog is closed
      let elHtml = document.getElementsByTagName('html')[0]
      elHtml.style.overflowY = 'auto'
    }
  },

  created() {
    // initialize the dialogs model from registered dialog components
    Object.keys(this.$options.components).forEach(component => {
      let dialogKey = String(component).charAt(0).toLowerCase()
          + String(component).slice(1).replace("Dialog", "");
      this.dialogs[dialogKey] = {
        visible: false,
        data: null
      }
    })
  }
};
</script>

<style lang="scss">
@import '~@/styles/app.scss';
@import '~@/styles/dialog.scss';
</style>
